import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { userManager } from '../auth/oidc'

export default function Callback() {
  const navigate = useNavigate()
  const handled = useRef(false)

  useEffect(() => {
    // Guard against React 18 StrictMode, which runs effects twice in development.
    // signinRedirectCallback() consumes the one-time auth code from the URL —
    // a second call would fail with "no state in storage" and redirect to login.
    if (handled.current) return
    handled.current = true

    userManager
      .signinRedirectCallback()   // exchanges the auth code for tokens, stores session
      .then(() => navigate('/clients', { replace: true }))
      .catch((err: unknown) => {
        console.error('OIDC callback error', err)
        navigate('/', { replace: true })
      })
  }, [navigate])

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <p>Completing sign-in…</p>
    </div>
  )
}
